// Umami custom events (cookie-free; see the privacy policy). No-op when the
// script is blocked or hasn't loaded, so callers never need to guard.
export const track = (event, data) => {
  try {
    if (typeof window !== 'undefined' && window.umami && typeof window.umami.track === 'function') {
      window.umami.track(event, data);
    }
  } catch {
    // analytics must never break the page
  }
};
